import { ApiResult } from 'interfaces/APITypes';
import { TagParams } from 'interfaces/StudioTypes';

import { contentInstance, makeRequest } from './client';

export const getTags = async (values?: TagParams): Promise<ApiResult> => {
  return makeRequest(
    contentInstance.get('/tags', {
      params: values,
    }),
  );
};
